import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-[#193B7F] to-[#45C1E0] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4">{t.footer.about}</h3>
            <p className="text-blue-100 leading-relaxed">
              {t.footer.description}
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-4">{t.footer.services}</h3>
            <ul className="space-y-2 text-blue-100">
              <li className="hover:text-[#45C1E0] transition-colors duration-200 cursor-pointer">
                {t.services.processes.title}
              </li>
              <li className="hover:text-[#45C1E0] transition-colors duration-200 cursor-pointer">
                {t.services.costs.title}
              </li>
              <li className="hover:text-[#45C1E0] transition-colors duration-200 cursor-pointer">
                {t.services.pricing.title}
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4">{t.footer.contact}</h3>
            <div className="space-y-3 text-blue-100">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 flex-shrink-0 mt-1" />
                <div>
                  <div className="font-semibold">Londrina - Paraná</div>
                  <div className="text-sm">Brasil</div>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 flex-shrink-0 mt-1" />
                <a
                  href="mailto:contato@smartinconsultoria.com.br"
                  className="hover:text-[#45C1E0] transition-colors duration-200"
                >
                  contato@smartinconsultoria.com.br
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="h-5 w-5 flex-shrink-0 mt-1" />
                <a
                  href="https://wa.me/5543991045996"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#45C1E0] transition-colors duration-200"
                >
                  +55 43 99104-5996
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-blue-800 mt-8 pt-8 text-center">
          <p className="text-blue-100">
            © {currentYear} SMARTIN Consultoria. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
